import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import {
  viewRewardVoucher,
  updateRewardVoucher,
} from "../../Redux/Actions/rewardsAction";
// import { ToFirstCapital } from "../../Utils/helpers";
import SearchBar from "../Main/searchBar";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import "./viewReward.css";

const ViewRewards = () => {
  const { id } = useParams();
  console.log("id from params:", id);
  const dispatch = useDispatch();
  const rewardState = useSelector((state) => state.rewards || {});

  const [status, setStatus] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (id) dispatch(viewRewardVoucher(id));
    else console.warn("No reward voucher ID found in URL");
  }, [dispatch, id]);

  useEffect(() => {
    if (rewardState.rewardDetails?.status) {
      setStatus(rewardState.rewardDetails.status);
    }
  }, [rewardState.rewardDetails]);

  const data = rewardState.voucherDetails || {};
  console.log("Reward details from state:", rewardState.rewardDetails);

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
    setShowConfirm(true);
  };

  const confirmStatusChange = () => {
    setIsUpdating(true);
    setShowConfirm(false);
    dispatch(updateRewardVoucher(data._id, selectedStatus)).finally(() =>
      setIsUpdating(false)
    );
  };

  return (
    <div className="view-voucher-container">
      <div className="view-voucher-grid padding-20 gap-10 grid-container">
        <div style={{ gridColumn: "3/8" }}>
          <SearchBar style={{ width: "max-content" }} />
        </div>

        <div className="view-voucher-header back-icon margin-0 gap-10 align-center flex-container">
          <Link to="/rewards">
            <BackIcon style={{ cursor: "pointer" }} />
          </Link>
          <div className="view-voucher-title-section referral-view">
            <h3 className="view-voucher-main-title">Reward Voucher Details</h3>
            <h4 className="view-voucher-breadcrumb">Rewards / List / View</h4>
          </div>
        </div>

        <div
          className={`view-voucher-content overall-container ${
            isUpdating ? "updating" : ""
          }`}
          style={{ background: "#fff"}}
        >
          {/* Hero Card with Image and Key Info */}
          <div className="voucher-hero-card">
            {data.image && (
              <div className="voucher-image-wrapper">
                <span className="voucher-image-label">Voucher Image</span>
                <img
                  src={data.image}
                  alt={data.title}
                  className="voucher-image"
                />
              </div>
            )}

            <div className="voucher-info-grid">
              <div className="voucher-info-item voucher-code-item">
                <span className="voucher-info-label">Voucher Code</span>
                <h2 className="voucher-info-value voucher-code-value">
                  {data.voucher || "No Data"}
                </h2>
              </div>

              <div className="voucher-info-item voucher-points-item">
                <span className="voucher-info-label">Reward Points</span>
                <h2 className="voucher-info-value voucher-points-value">
                  {data.reward_points ?? "No Data"}
                </h2>
              </div>

              <div className="voucher-info-item">
                <span className="voucher-info-label">Title</span>
                <h2 className="voucher-info-value">
                  {data.title || "No Data"}
                </h2>
              </div>

              <div className="voucher-info-item">
                <span className="voucher-info-label">Category</span>
                <h2 className="voucher-info-value">
                  {data.category || "No Data"}
                </h2>
              </div>
              
              <div className="voucher-info-item">
                <span className="voucher-info-label">Position</span>
                <h2 className="voucher-info-value">
                  {data.position || "No Data"}
                </h2>
              </div>
              <div className="voucher-info-item">
                <span className="voucher-info-label">Country</span>
                <h2 className="voucher-info-value">
                  {data.country?.country_name || "No Data"}
                </h2>
              </div>

              <div className="voucher-info-item full-width voucher-brochure-item">
                <span className="voucher-info-label">Brochure</span>
                {data.brochure ? (
                  <a
                    href={data.brochure}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="voucher-brochure-link"
                  >
                    <svg
                      className="voucher-brochure-icon"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                    <span>View Brochure</span>
                    <svg
                      className="voucher-external-icon"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      />
                    </svg>
                  </a>
                ) : (
                  <span className="voucher-info-value voucher-no-data-text">
                    No Brochure Available
                  </span>
                )}
              </div>

              <div className="voucher-info-item full-width">
                <span className="voucher-info-label">Description</span>
                <h4 className="voucher-info-value voucher-description">
                  {data.description || "No Data"}
                </h4>
              </div>
            </div>
          </div>

          {/* Terms & Conditions */}
          <div className="voucher-details-section">
            <h4 className="voucher-section-title">Terms & Conditions</h4>
            <ul className="voucher-list">
              {(data.terms_and_conditions || []).length > 0 ? (
                data.terms_and_conditions.map((term, idx) => (
                  <li key={idx} className="voucher-list-item">
                    {term}
                  </li>
                ))
              ) : (
                <li className="voucher-no-data">No Data</li>
              )}
            </ul>
          </div>

          {/* How to Redeem */}
          <div className="voucher-details-section">
            <h4 className="voucher-section-title">How to Redeem</h4>
            <ul className="voucher-list">
              {(data.how_to_redeem || []).length > 0 ? (
                data.how_to_redeem.map((step, idx) => (
                  <li key={idx} className="voucher-list-item">
                    {step}
                  </li>
                ))
              ) : (
                <li className="voucher-no-data">No Data</li>
              )}
            </ul>
          </div>

          {/* Status Dropdown - Uncomment if needed */}
          {/* <div className="voucher-status-section">
            <div className="voucher-status-wrapper">
              <span className="voucher-status-label">Status</span>
              <select
                value={status}
                onChange={handleStatusChange}
                className="voucher-status-select"
                disabled={isUpdating}
              >
                <option value="" disabled>
                  Select Status
                </option>
                {["active", "inactive"].map((stat) => (
                  <option key={stat} value={stat}>
                    {ToFirstCapital(stat)}
                  </option>
                ))}
              </select>
              {isUpdating && (
                <p className="voucher-updating-text">Updating status...</p>
              )}
            </div>
          </div> */}

          {/* Confirm Modal - Uncomment if needed */}
          {/* {showConfirm && (
            <div className="voucher-modal-backdrop">
              <div className="voucher-modal-content">
                <p className="voucher-modal-text">
                  Are you sure you want to change status to "
                  {ToFirstCapital(selectedStatus)}"?
                </p>
                <div className="voucher-modal-buttons">
                  <button
                    onClick={confirmStatusChange}
                    disabled={isUpdating}
                    className="voucher-modal-btn voucher-modal-btn-yes"
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => setShowConfirm(false)}
                    disabled={isUpdating}
                    className="voucher-modal-btn voucher-modal-btn-no"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default ViewRewards;
